import React from 'react';
import style from './Logo.module.scss';
import logo from '../../assets/images/logo-round.png';

// eslint-disable-next-line react/prop-types
function Logo({ color }) {
  return (
    <div className={style.app}>
      <img src={logo} alt="logo" />
      <div style={{ color }}>HEYBAN</div>
    </div>
  );
}

export default Logo;
